import { render, staticRenderFns } from "./BsTabs.vue?vue&type=template&id=888178fa&"
import script from "./BsTabs.vue?vue&type=script&lang=js&"
export * from "./BsTabs.vue?vue&type=script&lang=js&"
import style0 from "./BsTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports